<template>
  <p class="a-fadeout" id="component-swert" v-show="msg" v-text="msg"></p>
</template>
<style lang="stylus">
#component-swert
  position fixed
  top 50%
  left 50%
  -webkit-transform translate(-50%, -50%)
  -ms-transform translate(-50%, -50%)
  transform translate(-50%, -50%)
  padding 0.35rem 0.5rem
  max-width 80%
  border-radius 0.04rem
  word-break keep-all
  word-wrap break-word
  font-size 0.32rem
  color #fff
  background-color rgba(68, 68, 68, 0.88)
  z-index 9999
  text-align center

  &.a-fadeout
    -webkit-animation fadeout 2s ease-in forwards
    -moz-animation fadeout 2s ease-in forwards
    -ms-animation fadeout 2s ease-in forwards
    animation fadeout 2s ease-in forwards

@keyframes fadeout
  0%
    opacity 1

  70%
    opacity 0.7

  100%
    opacity 0

@keyframes fadeout
  0%
    opacity 1

  70%
    opacity 0.7

  100%
    opacity 0

@keyframes fadeout
  0%
    opacity 1

  70%
    opacity 0.7

  100%
    opacity 0

@keyframes fadeout
  0%
    opacity 1

  70%
    opacity 0.7

  100%
    opacity 0
</style>
<script>
export default {
  props: {
    value: String,
  },
  data() {
    return {
      msg: this.value,
    };
  },
  watch: {
    value(val) {
      this.msg = val;
    },
    msg(val) {
      this.$emit('input', val);
    },
  },
  mounted() {
    const swert = document.getElementById('component-swert');
    swert.addEventListener('webkitAnimationEnd', () => (this.msg = ''));
    swert.addEventListener('animationEnd', () => (this.msg = ''));
  },
};
</script>
